import axios from 'axios'
import { getAPIUrl } from '../API'

export interface SearchPropertyBySectionalTitleNameRequest {
  sectionalTitleName: string
  region: string
}

export interface SectionalTitleNameResponse {
  schemeName: string
  address: string
  suburb: string
  schemeNo: number
  mun_name: string
  region: string
}

export type SearchPropertyBySectionalTitleNameResponse =
  SectionalTitleNameResponse[]

export const searchPropertyBySectionalTitleName: (
  options: SearchPropertyBySectionalTitleNameRequest,
) => Promise<SearchPropertyBySectionalTitleNameResponse> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/searchpropertybysectionaltitlename`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  if (!data.data) {
    alert(
      `No results found for Sectional Title Scheme: ${options.sectionalTitleName}`,
    )
  }
  return data.data
}
